import { render } from "./AuctionArchiveWidget.vue?vue&type=template&id=7060b11f&scoped=true&ts=true"
import script from "./AuctionArchiveWidget.vue?vue&type=script&lang=ts"
export * from "./AuctionArchiveWidget.vue?vue&type=script&lang=ts"

import "./AuctionArchiveWidget.vue?vue&type=style&index=0&id=7060b11f&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7060b11f"]])

export default __exports__